import { render, staticRenderFns } from "./entity-card-care-partners-detail-extra-information.vue?vue&type=template&id=54a67971&"
import script from "./entity-card-care-partners-detail-extra-information.vue?vue&type=script&lang=js&"
export * from "./entity-card-care-partners-detail-extra-information.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports